import { render } from "./RegistroEmpresas.vue?vue&type=template&id=1c40df1f&scoped=true"
import script from "./RegistroEmpresas.vue?vue&type=script&lang=js"
export * from "./RegistroEmpresas.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./RegistroEmpresas.vue?vue&type=style&index=1&id=1c40df1f&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c40df1f"]])

export default __exports__